import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { SortByStringPipe } from "../../../core/pipes/sort-by-string.pipe";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { StarRankerComponent } from "../../common/star-ranker/star-ranker.component";

@Component({
  selector: "app-test-case-table",
  standalone: true,
  imports: [
    ZorroTableComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    StarRankerComponent,
    SortByStringPipe
  ],
  templateUrl: "./test-case-table.component.html",
  styleUrl: "./test-case-table.component.scss",
})
export class TestCaseTableComponent implements OnInit, OnChanges {
  @ViewChild(ZorroTableComponent) zorroTableComponent!: ZorroTableComponent;
  @Input() configs: any = {};
  @Input() zorroOptions: any = {};
  @Input() meta: any = {};
  @Input() isTestCase: boolean = false;

  // configs: any = {
  //   columns: testCaseTableColumns,
  //   rows: testCaseTableData,
  //   titleKey: "testScenario", //to highlight the title content
  //   isEdit: true, //edit button on top right, editable fields
  //   isFeedback: true, //to add feedback
  // };
  selectedRow: any = null;
  feedbackRow: any = null;
  editMode: boolean = false;
  selectedFeedback: string | null = null;

  @Output() handleActions = new EventEmitter<any>();
  @Output() onRowSelect = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<any>();

  ngOnInit() {
    if (this.configs?.rows.length > 0) {
      let item = {
        type: "row-click",
        data: {
          row: this.configs?.rows[0],
        },
      };
      this.handleTableActions(item);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['configs'] && changes['configs'].currentValue) {
      const updatedConfigs = changes['configs'].currentValue;
      if (updatedConfigs.rows?.length > 0) {
        const item = {
          type: "row-click",
          data: {
            row: updatedConfigs.rows[0],
          },
        };
        this.handleTableActions(item);
      }
    }
  }

  handleFilterActions(event: any) {
    if(event?.type === 'rank') {
      this.selectedRow = this.configs.rows.filter((ele: any) => !ele.hideRow).length ? this.configs.rows.filter((ele: any) => !ele.hideRow)[0] : null;
    }
  }

  handleTableActions(event: any, iconIndex?: number) {
     if (event.type == "row-click") {
      let rowIndex = this.configs.rows.findIndex(
        (item: any) => event?.data?.row?.id === item.id
      );
      this.selectedRow = this.configs.rows[rowIndex];
    } else {
      if (iconIndex === 0 || iconIndex === 1) {
        let feedbackObjIndex = this.configs.rows.findIndex(
          (item: any) => this.selectedRow.id === item.id
        );
       this.configs.rows = this.configs.rows.map((row:any) =>
        row.id === this.selectedRow.id
          ? { ...row, isThumbUp: true }
          : row
      );

      } else {
        let feedbackObjIndex = this.configs.rows.findIndex(
          (item: any) => this.selectedRow.id === item.id
        );
        this.configs.rows[feedbackObjIndex].feedback =
          this.selectedRow?.feedback;
        event.key = "feedback";
        event.data = this.configs.rows[feedbackObjIndex];
        console.log(event?.data);
      }
    }

    this.handleActions.emit(event);
  }

  onThumbClick(iconIndex: number) {
  const rowIndex = this.configs.rows.findIndex(
    (item:any) => item.id === this.selectedRow.id
  );
  const isThumbUp = iconIndex === 0;
  // Update state
  this.configs.rows[rowIndex].isThumbUp = isThumbUp;

  // Clear feedback if thumb up
  if (isThumbUp) {
    this.configs.rows[rowIndex].feedback = '';
  }

  // Sync selectedRow (important!)
  this.selectedRow = { ...this.configs.rows[rowIndex] };

  // Emit event immediately
  this.handleActions.emit({
    key: 'feedback',
    type: 'thumb-click',
    data: this.configs.rows[rowIndex]
  });
}


onFeedbackSave() {
  const rowIndex = this.configs.rows.findIndex(
    (item:any) => item.id === this.selectedRow.id
  );

  this.configs.rows[rowIndex].feedback = this.selectedRow.feedback;

  this.handleActions.emit({
    key: 'feedback',
    type: 'text-change',
    data: this.configs.rows[rowIndex]
  });
}

  handleRowSelection(event: any) {
    this.onRowSelect.emit(event);
  }

  isString(value: any): boolean {
    return typeof value === "string";
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  toggleEdit() {
    this.editMode = !this.editMode;

    if (!this.editMode) {
      console.log(this.selectedRow);
      this.saveChanges();
    }
  }

  saveChanges() {
    let data={
      type:'save',
      data:this.selectedRow
    }
    this.handleActions.emit(data);
  }

  openReport() {
    let data={
      type:'open-report',
      data:this.selectedRow.qualityReportId
    }
    this.handleActions.emit(data);
  }

  handleFeedback(i: number) {
    this.selectedFeedback = i === 0 ? "up" : "down";
  }

  getDisplayKeys(obj: any): string[] {
    const excludedKeys = ["id", "level", "expand"];

    const keys = Object.keys(obj).filter(
      (key) => !excludedKeys.includes(key.toLowerCase())
    );

    if (this.configs?.titleKey && keys.includes(this.configs?.titleKey)) {
      // Move titleKey to the beginning
      return [
        this.configs?.titleKey,
        ...keys.filter((k) => k !== this.configs?.titleKey),
      ];
    } else {
      return keys;
    }
  }

  formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, " $1") // space before capital
      .replace(/_/g, " ") //replace underscores
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1)) //capitalize
      .trim();
  }

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }

  public updatePageSize(size: number): void {
    if (this.zorroTableComponent) {
      this.zorroTableComponent.updatePageSize(size);
    }
  }

  getPriorityClass(priority: string): string {
    switch (priority?.toLowerCase()) {
      case 'p1':
      case 'critical':
        return 'priority-critical';

      case 'p2':
      case 'high':
        return 'priority-high';

      case 'p3':
      case 'medium':
        return 'priority-medium';

      case 'p4':
      case 'low':
        return 'priority-low';

      default:
        return 'priority-default';
    }
  }

  getPriorityLabel(priority: string): string {
  switch (priority?.toUpperCase()) {
    case 'P1':
      return 'Critical';

    case 'P2':
      return 'High';

    case 'P3':
      return 'Medium';

    case 'P4':
      return 'Low';

    default:
      return priority;
  }
}

  handleTestCaseFilterAction( event: any){
    this.handleActions.emit({
      type:'open-filter',
      data:this.selectedRow
    });
  }

  openStory(){
    this.handleActions.emit({
      type:'open-user-story',
      data:this.selectedRow
    });
  }

  openTraceability(){
    this.handleActions.emit({
      type:'open-traceability',
      data:{
        traceability: this.selectedRow?.traceability,
        key: this.selectedRow?.key
      }
    });
  }

  hasBulletMarkers(value: any): boolean {
    if (typeof value !== 'string') return false;
    return /(?:^|\s)[*#]\s/.test(value);
  }

  parseBulletPoints(value: string): string[] {
    return value
      .split(/\s*[*#]\s+/)
      .map(s => s.trim())
      .filter(s => s.length > 0);
  }

  getCoveredCount(traceability: string, key: string): number {
    if (!traceability || !key) {
      return 0;
    }

    const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const matches = traceability.match(
      new RegExp(`${escapedKey}\\s*:`, 'g')
    );

    return matches ? matches.length : 0;
  }
}
